import React from 'react'
import {connect} from 'react-redux'
import {
    Button,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    Popconfirm,
    Row,
    Select,
    Space,
    Spin,
    Tooltip,
    Typography,
    Upload
} from 'antd'
import {
    ArrowLeftOutlined,
    DeleteOutlined,
    EditOutlined,
    FileAddOutlined,
    InboxOutlined,
    MinusCircleOutlined,
    PlusOutlined
} from '@ant-design/icons'
import {withRouter} from 'react-router'
import moment from 'moment'
import {IN_PRODUCT} from '../../config/product'

import FormButton from '../../component/base/FormButton'
import {uploadImage} from '../../api/amazonS3'
import {deleteArtwork, getArtworkById, patchArtwork, postArtwork, postArtworkAdmin} from '../../api/artworks'
import {getArtworkConfig, patchArtworkConfig, postArtworkConfig} from '../../api/artworkConfigs'
import {processImage} from '../../api/colorAutoTagging'

import {getFileNameByUrl, getFullNameByArtist, validateMessages} from '../../app/util'
import FormErrorMessage from '../../component/base/FormErrorMessage'
import SubjectSelect from '../../component/piece/SubjectSelect'

import '../../asset/less/NewPieces.css'
import HttpError from '../../component/base/HttpError'
import ColorTypeSelect from '../../component/piece/ColorTypeSelect'
import {sanity_s3_url_display} from '../../component/Utils'
import {URL_PIECES} from '../../const'
import axios from "axios";
import {is_admin_user} from "../../app/role";

const {Option} = Select
const {Title, Text} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role,
    artists: state.artist.artists
}))
class NewPieces extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            validateError: [],
            colorTaggingConfirmVisible: false,
            colorTaggingLoading: false,
            deletePopconfirmVisible: false,
            deleteButtonLoading: false,
            printsItemsVisible: false,
            printsPriceOptionsVisible: false
        }
        this.state.loading = props.new !== true
        this.requestDataToken = axios.CancelToken.source()
        this.artists = props.artists.map((artist) => ({
            id: artist.artist,
            name: getFullNameByArtist(artist)
        }))
        this.initMultipleSelect = (str) => {
            if (str) {
                if (str === '') return []
                return str.split(',')
            } else {
                return []
            }
        }
        this.sanityDimsNum = (num) => {
            try {
                const val = parseFloat(num)
                if (isNaN(val)) return ''
                return val
            } catch (e) {
                console.log(e)
            }
            return ''
        }
        this.printPriceformItemLayout = {
            labelCol: {
                xs: {
                    span: 24
                },
                sm: {
                    span: 4
                }
            },
            wrapperCol: {
                xs: {
                    span: 24
                },
                sm: {
                    span: 20
                }
            }
        }
        this.printPriceformItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0
                },
                sm: {
                    span: 20,
                    offset: 4
                }
            }
        }
    }

    getArtworkId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArray = this.props.location.pathname.split('/')
            if (locationArray[locationArray.length - 1] !== '') {
                id = parseInt(locationArray[locationArray.length - 1])
            } else if (locationArray[locationArray.length - 2] !== '') {
                id = parseInt(locationArray[locationArray.length - 2])
            }
        }
        return id
    }

    getArtworkUrl = (id, name) => {
        if (!name) return ''
        let f = name
        f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
        f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
        f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
        f = f.replaceAll('&', 'and').replaceAll(',', '')

        return f + '_' + id
    }

    componentDidMount() {
        if (this.props.new === true) return
        let id = this.getArtworkId()
        Promise.all([getArtworkById(id, this.requestDataToken), getArtworkConfig(id, this.requestDataToken)])
            .then((response) => {
                this.setState({
                    loading: false
                })
                // let pieces_data = [];
                // response[2].data.results.forEach((item) => {
                //   pieces_data.push({
                //     id: item.id,
                //     s3_url: item.s3_url,
                //     static_url: item.static_url,
                //     size: item.file_size
                //   });
                // })
                this.initializeFieldsValue(response[0].data, response[1].data)
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    return
                }
                HttpError(error)
            })
    }

    componentWillUnmount() {
        if (this.requestDataToken) {
            this.requestDataToken.cancel("cancel")
        }
    }

    initializeFieldsValue = (artwork, artworkConfig) => {
        if (this.formRef.current == null) return
        let sizes = artwork.size_type_str?.split(',') ?? []
        if (sizes && sizes.length !== 3) {
            sizes = [0, 0, 0]
        }
        const userCreatedDate = moment(artworkConfig.user_created_date, 'YYYY-MM-DD')
        const userUpdatedDate = moment(artwork.updated_at, 'YYYY-MM-DD')
        let pieces_array
        if (artwork.artwork_pieces_str) {
            let pieces = artwork.artwork_pieces_str
            pieces_array = JSON.parse(pieces)
        } else {
            pieces_array = []
        }
        let used_type = this.initMultipleSelect(artwork.used_type)
        if (used_type.includes('prints')) {
            this.setState({printsItemsVisible: true})
        }

        let imageFileSize = parseInt(artwork.file_size)
        this.formRef.current.setFieldsValue({
            name: artwork.name,
            medium_type_str: this.initMultipleSelect(artwork.medium_type_str), // mediums
            material_type_str: artwork.material_type_str, // materials
            style_type_str: this.initMultipleSelect(artwork.style_type_str), // styles
            label_str: artwork.label_str, // tags
            price_type_str: artwork.price_type_str ?? null, // price
            extra_info_str: artwork.extra_info_str, // description
            used_type: used_type, // business type
            content_info_str: this.initMultipleSelect(artwork.content_info_str), // subject matters
            color_info_str: this.initMultipleSelect(artwork.color_info_str),
            height: this.sanityDimsNum(sizes[0]),
            width: this.sanityDimsNum(sizes[1]),
            depth: this.sanityDimsNum(sizes[2]),
            size_desc_str: artwork.size_desc_str,
            image: [
                {
                    name: getFileNameByUrl(artwork.s3_url),
                    status: 'done',
                    thumbUrl: sanity_s3_url_display(artwork.static_url),
                    url: artwork.s3_url,
                    size: isNaN(imageFileSize) ? 1 : imageFileSize
                }
            ],
            additional_image: pieces_array.map((d) => ({
                name: d.name,
                size: d.size,
                status: d.status,
                thumbUrl: sanity_s3_url_display(d.thumbUrl),
                url: d.url,
                response: {
                    s3_url: d.url,
                    static_url: d.thumbUrl
                }
            })),
            artist: artwork.artist_id,

            is_visible_gallery: !artworkConfig.is_visible_gallery,
            is_display_watermark: artworkConfig.is_display_watermark,
            is_framed: artwork.is_framed,
            frame_size_d: artwork.frame_size_d,
            frame_size_h: artwork.frame_size_h,
            frame_size_w: artwork.frame_size_w,
            frame_desc: artwork.frame_desc ?? null,
            inventory_quantity: artworkConfig.inventory_quantity,
            inventory_prints_quantity: artworkConfig.inventory_prints_quantity,
            inventory_in_use: artworkConfig.inventory_in_use,
            inventory_prints_in_use: artworkConfig.inventory_prints_in_use,
            inventory_history_json: artworkConfig.inventory_history_json,
            prints_markup_percentage: artworkConfig.prints_markup_percentage,
            is_custom_prints_options: artworkConfig.is_custom_prints_options,
            year: artwork.year === -1 ? undefined : artwork.year,
            month: userCreatedDate.isValid() ? userCreatedDate.format('MM') : undefined,
            day: userCreatedDate.isValid() ? userCreatedDate.format('DD') : undefined
        })
        if (artworkConfig.is_custom_prints_options && artworkConfig.custom_prints_options) {
            let option_str_array = artworkConfig.custom_prints_options.split(';')
            let option_array = []
            for (let option of option_str_array) {
                let option_parts = option.split(':')
                option_array.push({
                    price_option: option_parts[0],
                    price_value: option_parts[1]
                })
            }
            this.formRef.current.setFieldsValue({
                prints_price_options: option_array
            })
        }
        this.onYearAndMonthChange()
        this.setState({
            loading: false,
            artwork_name: artwork.name,
            user_updated_date: userUpdatedDate,
            artwork_config_id: artworkConfig.id,
            printsPriceOptionsVisible: artworkConfig.is_custom_prints_options,
            base_url: IN_PRODUCT ? 'https://revart.co' : 'http://localhost:8000'
        })
        if (artwork.color_info_str === null || artwork.color_info_str === '') {
            this.setState({
                colorTaggingLoading: true
            })
            processImage(artwork.static_url)
                .then((res) => {
                    let color_str = res.join(',')
                    color_str = color_str.toUpperCase()
                    this.formRef.current.setFieldsValue({
                        color_info_str: this.initMultipleSelect(color_str)
                    })
                    this.setState({
                        colorTaggingConfirmVisible: true
                    })
                })
                .catch((e) => {
                    HttpError(e)
                })
                .finally(() => {
                    this.setState({
                        colorTaggingLoading: false
                    })
                })
        }
    }

    customRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    customRequestOnChange = (e) => {
        const {file} = e
        if (file && file.status === 'done' && file.response) {
            this.setState({
                colorTaggingLoading: true
            })
            processImage(file.response.static_url)
                .then((res) => {
                    let color_str = res.join(',')
                    color_str = color_str.toUpperCase()
                    this.setState({
                        colorTaggingConfirmVisible: true
                    })
                    this.formRef.current.setFieldsValue({
                        color_info_str: this.initMultipleSelect(color_str)
                    })
                })
                .catch((e) => {
                    HttpError(e)
                })
                .finally(() => {
                    this.setState({
                        colorTaggingLoading: false
                    })
                })
        }
    }

    onFinishFailed = ({values, errorFields, outOfDate}) => {
        this.setState({validateError: errorFields})
    }

    onFinish = (values) => {
        this.setState({validateError: []})
        const {
            name,
            medium_type_str,
            image,
            additional_image,
            material_type_str,
            style_type_str,
            content_info_str,
            color_info_str,
            label_str,
            year,
            month,
            day,
            price_type_str,
            extra_info_str,
            height,
            width,
            depth,
            size_desc_str,
            is_visible_gallery,
            is_display_watermark,
            is_framed,
            frame_desc,
            used_type,
            inventory_quantity,
            inventory_prints_quantity,
            prints_markup_percentage,
            prints_price_options,
            is_custom_prints_options
        } = values

        let additional_image_json_array = []
        let additional_image_str = undefined
        if (additional_image) {
            for (let i = 0; i < additional_image.length; i++) {
                let item = additional_image[i]
                const fileSize = parseInt(item.file_size)
                additional_image_json_array.push({
                    name: getFileNameByUrl(item.response.s3_url),
                    status: 'done',
                    thumbUrl: item.response.static_url,
                    url: item.response.s3_url,
                    size: isNaN(fileSize) ? 1 : fileSize
                })
            }
            additional_image_str = JSON.stringify(additional_image_json_array)
        }
        const artworkParam = {
            name,
            medium_type_str: medium_type_str?.join(','),
            material_type_str: material_type_str,
            style_type_str: style_type_str?.join(','),
            label_str,
            year,
            price_type_str,
            extra_info_str,
            is_framed,
            frame_size_h: height,
            frame_size_w: width,
            frame_size_d: depth,
            frame_desc: frame_desc,
            size_type_str: height + ',' + width + ',' + depth,
            size_desc_str: size_desc_str,
            s3_url: image[0].response !== undefined ? image[0].response.s3_url : image[0].url,
            static_url: image[0].response !== undefined ? image[0].response.static_url : image[0].thumbUrl,
            file_size: isNaN(image[0].size) ? 1 : image[0].size,
            used_type: used_type === undefined || used_type.length === 0 ? '' : used_type?.join(','),
            artwork_pieces_str: additional_image_str,
            content_info_str: content_info_str?.join(','),
            color_info_str: color_info_str?.join(',')
        }
        const user_created_date = moment(`${year}-${month ?? '01'}-${day ?? '01'}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
        const artworkConfigParam = {
            is_visible_gallery: !is_visible_gallery,
            is_display_watermark: !!is_display_watermark,
            user_created_date,
            inventory_quantity: inventory_quantity,
            inventory_prints_quantity: inventory_prints_quantity,
            prints_markup_percentage: prints_markup_percentage,
            is_custom_prints_options: is_custom_prints_options
        }
        if (prints_price_options && is_custom_prints_options) {
            let sanity = (str) => {
                return str.replaceAll(':', '').replaceAll(';', '')
            }
            let item_str = []
            for (const item of prints_price_options) {
                let str = sanity(item.price_option) + ':' + item.price_value
                item_str.push(str)
            }
            artworkConfigParam['custom_prints_options'] = item_str.join(';')
        }
        if (this.props.new === true) {
            if (!is_admin_user(this.props)) {
                postArtwork(artworkParam)
                    .then(async (response) => {
                        await postArtworkConfig({
                            artwork: response.data.id,
                            ...artworkConfigParam
                        })
                        message.success('Save successfully').then((r) => {
                        })
                        this.props.history.push({pathname: URL_PIECES})
                    })
                    .catch((error) => {
                        HttpError(error)
                    })
            } else {
                postArtworkAdmin({artist: values.artist, ...artworkParam})
                    .then(async (response) => {
                        await postArtworkConfig({
                            artwork: response.data.id,
                            ...artworkConfigParam
                        })
                        message.success('Save successfully').then((r) => {
                        })
                        this.props.history.push({pathname: URL_PIECES})
                    })
                    .catch((error) => {
                        HttpError(error)
                    })
            }
        } else {
            const id = this.getArtworkId()
            Promise.all([patchArtwork(id, artworkParam), patchArtworkConfig(id, {artwork: id, ...artworkConfigParam})])
                .then((response) => {
                    message.success('Update successfully').then((r) => {
                    })
                    this.props.history.push({pathname: URL_PIECES})
                })
                .catch((error) => {
                    HttpError(error)
                })
        }
    }

    onYearAndMonthChange = () => {
        if (this.formRef.current == null) return
        const year = this.formRef.current.getFieldValue('year')
        if (year === undefined) return
        const month = this.formRef.current.getFieldValue('month')
        if (month === undefined) return
        this.setState({
            numberOfDays: this.getMonthDay(year, month)
        })
    }

    getMonthDay = (year, month) => {
        return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
    }

    onDeleteButtonClick = () => {
        this.setState({
            deleteButtonLoading: true
        })
        Promise.all([deleteArtwork(this.getArtworkId())])
            .then((response) => {
                message.success('Delete successfully!').then((r) => {
                })
                this.props.history.push({pathname: URL_PIECES})
            })
            .catch((error) => {
                HttpError(error)
            })
            .finally(() => {
                this.setState({
                    deleteButtonLoading: false,
                    deletePopconfirmVisible: false
                })
            })
    }

    render() {
        const yearOptions = []
        for (let year = moment().year(); year >= 1970; year--) {
            yearOptions.push({
                label: String(year),
                value: String(year)
            })
        }
        const dayOptions = []
        for (let day = 1; day <= this.state.numberOfDays; day++) {
            const dayString = day < 10 ? '0' + day : String(day)
            dayOptions.push({
                label: dayString,
                value: dayString
            })
        }
        return (
            <Spin size='large' spinning={this.state.loading}>
                <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col>
                        <Title level={2} style={{marginBottom: 0}}>
                            {this.props.new === true ? <FileAddOutlined/> : <EditOutlined/>}
                            {this.props.new === true ? ' New' : ' Edit'} Piece
                        </Title>
                    </Col>
                </Row>
                <FormErrorMessage error={this.state.validateError}/>
                <Form
                    colon={false}
                    ref={this.formRef}
                    labelAlign='left'
                    onFinish={this.onFinish}
                    validateMessages={validateMessages}
                    onFinishFailed={this.onFinishFailed}
                    style={{
                        marginTop: '16px',
                        padding: 12
                    }}
                >
                    <Row justify='space-between' gutter={{xs: 8, sm: 16, md: 24}}>
                        <Col xs={24} sm={24} md={12}>
                            {this.props.new !== true && (
                                <div style={{paddingBottom: 20}}>
                                    <span>Updated at: {this.state.user_updated_date?.format()} | </span>
                                    <a
                                        target={'_blank'}
                                        href={
                                            this.state.base_url + '/artworks/info/' + this.getArtworkUrl(this.getArtworkId(), this.state.artwork_name?.toString())
                                        }
                                        style={{textDecoration: 'underline'}}
                                        rel='noreferrer'
                                    >
                                        Check the Artwork Page
                                    </a>
                                </div>
                            )}
                            {is_admin_user(this.props) && (
                                <>
                                    <Form.Item name='artist' label='Artist Name (Admin)' rules={[{required: true}]}>
                                        <Select
                                            showSearch
                                            optionFilterProp='label'
                                            placeholder='Please select artist name'
                                            options={this.artists.map((artist) => ({
                                                value: artist.id,
                                                label: artist.name
                                            }))}
                                            disabled={!this.props.new}
                                        />
                                    </Form.Item>
                                </>
                            )}
                            <Form.Item
                                name='name'
                                label='Title'
                                rules={[
                                    {
                                        required: true,
                                        type: 'string',
                                        max: 100,
                                        min: 1
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                label='Style'
                                name='style_type_str'
                                rules={[
                                    {
                                        required: !is_admin_user(this.props)
                                    }
                                ]}
                            >
                                <Select mode='multiple' placeholder='Please select'>
                                    <Option value='fine-art'>Fine Art</Option>
                                    <Option value='abstract'>Abstract</Option>
                                    <Option value='modern'>Modern</Option>
                                    <Option value='street-art'>Street Art</Option>
                                    <Option value='pop-art'>Pop Art</Option>
                                    <Option value='mural-art'>Mural Art</Option>
                                    <Option value='public-art'>Public Art</Option>
                                    <Option value='illustration'>Illustration</Option>
                                    <Option value='others'>Others</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label='Medium'
                                name='medium_type_str'
                                rules={[
                                    {
                                        required: !is_admin_user(this.props)
                                    }
                                ]}
                            >
                                <Select mode='multiple' placeholder='Please select'>
                                    <Option value='painting'>Painting</Option>
                                    <Option value='drawing'>Drawing</Option>
                                    <Option value='sculpture'>Sculpture</Option>
                                    <Option value='collage'>Collage</Option>
                                    <Option value='mixed-media'>Mixed Media</Option>
                                    <Option value='installation-digital'>Installation Digital</Option>
                                    <Option value='others'>Other</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name='material_type_str'
                                label='Materials'
                                rules={[
                                    {
                                        required: !is_admin_user(this.props),
                                        type: 'string'
                                    }
                                ]}
                            >
                                <Input placeholder='for example, Oil on Canvas'/>
                            </Form.Item>
                            <Form.Item
                                name='content_info_str'
                                label='Subject Matter'
                                rules={[
                                    {
                                        required: false
                                    }
                                ]}
                            >
                                <SubjectSelect mode='multiple' placeholder='Please select' style={{width: '100%'}}/>
                            </Form.Item>
                            <Form.Item
                                name='label_str'
                                label='Tags (Comma separated)'
                                rules={[
                                    {
                                        min: 1,
                                        max: 100,
                                        type: 'string'
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Tooltip title='Our AI auto tagged the color for you'
                                     visible={this.state.colorTaggingConfirmVisible}>
                                <Spin size={'small'} spinning={this.state.colorTaggingLoading}>
                                    <Form.Item style={{height: 1, margin: 0}}></Form.Item>
                                </Spin>
                            </Tooltip>
                            <Form.Item
                                name='color_info_str'
                                label='Tag Color '
                                rules={[
                                    {
                                        required: false
                                    }
                                ]}
                            >
                                <ColorTypeSelect/>
                            </Form.Item>
                            <Row
                                align='middle'
                                style={{
                                    marginBottom: '24px'
                                }}
                            >
                                <Text style={{display: 'block', paddingRight: 24}}>Creation Date</Text>
                                <Col
                                    flex='auto'
                                    style={{
                                        marginLeft: '8px'
                                    }}
                                >
                                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                                        <Col>
                                            <Form.Item
                                                label='Year'
                                                name='year'
                                                rules={[
                                                    {
                                                        required: true
                                                    }
                                                ]}
                                                noStyle
                                            >
                                                <Select
                                                    placeholder={
                                                        <>
                                                            <Text type='secondary'>Year</Text>
                                                            <Text type='danger'>*</Text>
                                                        </>
                                                    }
                                                    onChange={this.onYearAndMonthChange}
                                                    options={yearOptions}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col>
                                            <Form.Item label='Month' name='month' noStyle>
                                                <Select placeholder='Month' onChange={this.onYearAndMonthChange}
                                                        style={{minWidth: '100px'}}>
                                                    <Option value={'01'}>January</Option>
                                                    <Option value={'02'}>February</Option>
                                                    <Option value={'03'}>March</Option>
                                                    <Option value={'04'}>April</Option>
                                                    <Option value={'05'}>May</Option>
                                                    <Option value={'06'}>June</Option>
                                                    <Option value={'07'}>July</Option>
                                                    <Option value={'08'}>August</Option>
                                                    <Option value={'09'}>September</Option>
                                                    <Option value={'10'}>October</Option>
                                                    <Option value={'11'}>November</Option>
                                                    <Option value={'12'}>December</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col>
                                            <Form.Item label='Day' name='day' noStyle>
                                                <Select placeholder='Day' options={dayOptions}
                                                        style={{minWidth: '30px'}}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Form.Item name='price_type_str' label='Price in US $'>
                                <Input/>
                            </Form.Item>
                            <Form.Item name='is_visible_gallery' valuePropName='checked' noStyle>
                                <Checkbox style={{marginBottom: '24px', marginLeft: 0}}>Private (Not display at artist
                                    showcase)</Checkbox>
                            </Form.Item>
                            <Form.Item name='is_display_watermark' valuePropName='checked' noStyle>
                                <Checkbox style={{marginBottom: '24px', marginLeft: 0}}>Add watermark when displayed
                                    online</Checkbox>
                            </Form.Item>
                            <Form.Item
                                label='Business Type'
                                name='used_type'
                                rules={[
                                    {
                                        required: !is_admin_user(this.props)
                                    }
                                ]}
                            >
                                <Select
                                    mode='multiple'
                                    placeholder='Please select'
                                    onChange={(val) => {
                                        this.setState({printsItemsVisible: val.includes('prints')})
                                    }}
                                >
                                    <Option value='original'>Selling Original</Option>
                                    <Option value='commission'>Take Commission</Option>
                                    <Option value='prints'>Available for Prints</Option>
                                    <Option value='licensing'>Licensing</Option>
                                </Select>
                            </Form.Item>
                            <Divider/>
                            <div style={{
                                fontSize: 12,
                                color: 'grey',
                                marginTop: 24,
                                marginBottom: 24,
                                textAlign: 'justify'
                            }}>
                                In less than 50 words, tell the story of this work. You can respond to questions
                                like, &quot;What/who inspired the
                                work?&quot; &quot;What do you hope its audience feels/thinks?&quot; &quot;Why did you
                                choose the medium, subject matter, and
                                style that you did?&quot;
                            </div>
                            <Text style={{display: 'block', marginTop: 24}} className='rightLabel'>
                                Artwork Story{' '}
                            </Text>
                            <Form.Item
                                name='extra_info_str'
                                label='Description'
                                rules={[
                                    {
                                        min: 1,
                                        max: 800,
                                        type: 'string'
                                    }
                                ]}
                                noStyle
                            >
                                <Input.TextArea autoSize={{minRows: 4, maxRows: 8}} showCount maxLength={800}/>
                            </Form.Item>
                            <Text style={{display: 'block', marginTop: 24}} className='rightLabel'>
                                Inventory{' '}
                            </Text>
                            <div className='rightContainer specificationsContainer' style={{padding: 36}}>
                                <Form.Item
                                    name='inventory_quantity'
                                    label='Quantity (Sell Original)'
                                    rules={[
                                        {
                                            required: false,
                                            type: 'integer'
                                        }
                                    ]}
                                >
                                    <InputNumber defaultValue={1}/>
                                </Form.Item>

                                <Form.Item
                                    name='inventory_prints_quantity'
                                    label='Quantity (Sell Prints)'
                                    rules={[
                                        {
                                            required: false,
                                            type: 'integer'
                                        }
                                    ]}
                                >
                                    <InputNumber defaultValue={50} disabled={!this.state.printsItemsVisible}
                                                 hidden={!this.state.printsItemsVisible}/>
                                </Form.Item>

                                <Form.Item name='prints_markup_percentage' label='Markup percentage (Prints) %'>
                                    <InputNumber defaultValue={20} disabled={!this.state.printsItemsVisible}
                                                 hidden={!this.state.printsItemsVisible}/>
                                </Form.Item>

                                <Form.Item
                                    name='inventory_in_use'
                                    label='In Use Quantity (Original)'
                                    rules={[
                                        {
                                            required: false,
                                            type: 'integer'
                                        }
                                    ]}
                                >
                                    <Input disabled={true} defaultValue={0}/>
                                </Form.Item>

                                <Form.Item

                                    name='inventory_prints_in_use'
                                    label='In Use Quantity (Prints)'
                                    visible={this.state.printsItemsVisible.toString()}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'integer'
                                        }
                                    ]}
                                >
                                    <Input disabled={true} defaultValue={0}/>
                                </Form.Item>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                            <Text className='rightLabel'>The Main Image</Text>
                            <Text type='danger'>*</Text>
                            <div className='rightContainer'>
                                <Form.Item
                                    name='image'
                                    label='The Main Image'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => {
                                        return e && e.fileList
                                    }}
                                    rules={[
                                        {
                                            required: true
                                        }
                                    ]}
                                    noStyle
                                >
                                    <Upload.Dragger
                                        accept='image/*'
                                        listType='picture'
                                        customRequest={this.customRequest}
                                        onChange={this.customRequestOnChange}
                                        maxCount={1}
                                    >
                                        <div className='uploadDraggerContainer'>
                                            <Button type='primary'> Choose File</Button>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                Notes:
                                            </Text>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                Image format supported: jpg, jpeg ...
                                            </Text>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                File size: Limited to 10MB
                                            </Text>
                                        </div>
                                    </Upload.Dragger>
                                </Form.Item>
                            </div>
                            <Text className='rightLabel'>Additional Images</Text>
                            <div className='rightContainer'>
                                <Form.Item
                                    name='additional_image'
                                    label='Additional Images'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => {
                                        return e && e.fileList
                                    }}
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                    noStyle
                                >
                                    <Upload.Dragger accept='image/*' listType='picture'
                                                    customRequest={this.customRequest} maxCount={4}>
                                        <div className='uploadDraggerContainer'>
                                            <Button type='primary'> Choose File</Button>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                Notes:
                                            </Text>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                Image format supported: jpg, jpeg ...
                                            </Text>
                                            <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                File size: Limited to 10MB
                                            </Text>
                                            <p className='ant-upload-drag-icon' style={{marginBottom: 0}}>
                                                <InboxOutlined style={{fontSize: '96px'}}/>
                                            </p>
                                        </div>
                                    </Upload.Dragger>
                                </Form.Item>
                            </div>
                            <Text className='rightLabel'>Specifications</Text>
                            <div className='rightContainer specificationsContainer'>
                                <Form.Item name='is_framed' label='Framed' valuePropName='checked' noStyle>
                                    <Checkbox style={{marginBottom: 12, marginLeft: 0}}>Framed - Artwork size with
                                        frame</Checkbox>
                                </Form.Item>
                                <Text style={{display: 'block'}}>Additional frame description (if have):</Text>
                                <Row>
                                    <Col span={24} style={{marginTop: 12, paddingLeft: 24, paddingRight: 24}}>
                                        <Form.Item name='frame_desc'>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Text>Dimensions of work (in inches)</Text>
                                {/*<Text type="danger">*</Text>*/}
                                <br/>
                                <Text type='secondary'>For flat artworks, such as works on paper, we suggest that you
                                    enter a depth of 0.1</Text>
                                <br/>
                                <Text type='secondary'>Use decimals when needed (eg. 10.5 instead of 10 1/2)</Text>
                                <Row gutter={{xs: 8, sm: 16, md: 24}} style={{marginBottom: '12px', marginTop: '12px'}}>
                                    <Col span={8}>
                                        <Form.Item
                                            label='Height'
                                            name='height'
                                            rules={[
                                                {
                                                    required: !is_admin_user(this.props),
                                                    type: 'number',
                                                    transform: (value) => {
                                                        return Number(value)
                                                    }
                                                }
                                            ]}
                                            noStyle
                                        >
                                            <Input prefix={<Text>H</Text>}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label='Width'
                                            name='width'
                                            rules={[
                                                {
                                                    required: !is_admin_user(this.props),
                                                    type: 'number',
                                                    transform: (value) => {
                                                        return Number(value)
                                                    }
                                                }
                                            ]}
                                            noStyle
                                        >
                                            <Input prefix={<Text>W</Text>}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label='Depth'
                                            name='depth'
                                            rules={[
                                                {
                                                    required: !is_admin_user(this.props),
                                                    type: 'number',
                                                    transform: (value) => {
                                                        return Number(value)
                                                    }
                                                }
                                            ]}
                                            noStyle
                                        >
                                            <Input prefix={<Text>D</Text>}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Text>Additional dimensions description (if have):</Text>
                                <Row>
                                    <Col span={24} style={{marginTop: 12, paddingLeft: 24, paddingRight: 24}}>
                                        <Form.Item name='size_desc_str'>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            {this.state.printsItemsVisible && (
                                <>
                                    <Text className='rightLabel'>Prints Price</Text>
                                    <div className='rightContainer specificationsContainer'>
                                        <Form.Item name='is_custom_prints_options' valuePropName='checked' noStyle>
                                            <Checkbox
                                                style={{marginBottom: 12, marginLeft: 0}}
                                                onChange={(e) => {
                                                    this.setState({printsPriceOptionsVisible: e.target.checked})
                                                }}
                                            >
                                                Select to use your own print price options, &quot;8 x 10 in
                                                $46&quot; for example.
                                            </Checkbox>
                                        </Form.Item>
                                        {this.state.printsPriceOptionsVisible && (
                                            <Form.List name='prints_price_options'>
                                                {(fields, {add, remove}) => (
                                                    <>
                                                        {fields.map(({key, name, ...restField}) => (
                                                            <Space
                                                                key={key}
                                                                style={{
                                                                    display: 'flex',
                                                                    marginBottom: 8
                                                                }}
                                                                align='baseline'
                                                            >
                                                                <span>Option {key + 1}</span>
                                                                <Form.Item
                                                                    {...restField}
                                                                    style={{
                                                                        marginRight: 6,
                                                                        marginLeft: 6,
                                                                        width: '100%'
                                                                    }}
                                                                    name={[name, 'price_option']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Missing price option'
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input placeholder='Ex. 8 x 10 in $46'/>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    {...restField}
                                                                    style={{marginLeft: 6, width: '100%'}}
                                                                    name={[name, 'price_value']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Missing price value',
                                                                            type: 'number',
                                                                            transform: (value) => {
                                                                                return Number(value)
                                                                            }
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input prefix='$' placeholder='Ex. 46'/>
                                                                </Form.Item>
                                                                <MinusCircleOutlined style={{marginLeft: 12}}
                                                                                     onClick={() => remove(name)}/>
                                                            </Space>
                                                        ))}
                                                        <Form.Item>
                                                            <Button type='dashed' onClick={() => add()} block
                                                                    icon={<PlusOutlined/>}>
                                                                Add field
                                                            </Button>
                                                        </Form.Item>
                                                    </>
                                                )}
                                            </Form.List>
                                        )}
                                    </div>
                                </>
                            )}
                        </Col>
                    </Row>
                    <FormButton>
                        {this.props.new ? (
                            <>
                                <Col
                                    xs={18}
                                    sm={16}
                                    md={16}
                                    lg={14}
                                    xl={14}
                                    xll={12}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'row',
                                        gap: 4,
                                        width: '100%',
                                        justifyContent: 'space-evenly',
                                        marginLeft: '10%',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <div>
                                        <Button block size='large'
                                                onClick={this.props.onCancelClick || this.props.history.goBack}>
                                            <ArrowLeftOutlined/>
                                            <span style={{fontSize: 14}}>Back</span>
                                        </Button>
                                    </div>
                                    <div>
                                        <Button block type='primary' size='large' htmlType='submit'>
                                            <FileAddOutlined/>
                                            <span style={{fontSize: 14}}>Create Piece</span>
                                        </Button>
                                    </div>
                                </Col>
                            </>
                        ) : (
                            <Col
                                xs={24}
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                }}
                            >
                                <div>
                                    <Popconfirm
                                        placement='top'
                                        title='Are you sure you want to permanently delete this and all its associated records?'
                                        visible={this.state.deletePopconfirmVisible}
                                        onConfirm={this.onDeleteButtonClick}
                                        okButtonProps={{loading: this.state.deleteButtonLoading}}
                                        onCancel={() => {
                                            this.setState({
                                                deletePopconfirmVisible: false
                                            })
                                        }}
                                    >
                                        <Button
                                            block
                                            danger
                                            size='large'
                                            onClick={() => {
                                                this.setState({
                                                    deletePopconfirmVisible: true
                                                })
                                            }}
                                            icon={<DeleteOutlined style={{paddingLeft: 16, paddingRight: 16}}/>}
                                        />
                                    </Popconfirm>
                                </div>
                                <div style={{marginLeft: 'auto', marginRight: '12%', display: 'flex'}}>
                                    <div style={{marginRight: '12%'}}>
                                        <Button block size='large' onClick={this.props.history?.goBack}>
                                            <ArrowLeftOutlined/>
                                            <span style={{fontSize: 14}}>Back</span>
                                        </Button>
                                    </div>
                                    <div>
                                        <Button block type='primary' size='large' htmlType='submit'>
                                            <EditOutlined/>
                                            <span style={{fontSize: 14}}>Update Piece</span>
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </FormButton>
                </Form>
            </Spin>
        )
    }
}

export default withRouter(NewPieces)
